<template>
	<div>
		<el-drawer
			title="我是标题"
			:visible.sync="drawer"
			:with-header="false"
			direction="ltr"
			:modal="false"
			ref="changeHeight"
			:style="'background-color: #143166'"
		>
			<div style="margin: 20px">
				<el-input v-model="search" placeholder="请输入搜索内容">
					<el-button slot="append" icon="el-icon-search" @click="queryArc()">搜索</el-button>
				</el-input>
			</div>
			<ul v-for="(item, index) in column" :key="index" :index="String(index)" @click="changColumn(item)">
				<li>
					<a href>{{ item }}</a>
				</li>
			</ul>
		</el-drawer>
		<div class="choose-city" v-if="close">
			<div class="icon-close">
				<i class="el-icon-circle-close" @click="closeIcon()"></i>
			</div>
			<div class="choose-city-content">
				<div class="choose-city-content1">
					<div class="choose-city-boxs">
						<div class="choose-city-box">
							<p class="choose-city-txt1">当前位置</p>
							<div class="showcity" style="clear: none">
								<a href>{{ city }}</a>
							</div>
						</div>
						<div class="choose-city-box">
							<p class="choose-city-txt1">地方站点</p>
							<div class="showcity1" v-for="item in region" :key="item" @click="passCity(item)">
								<a href>{{ item }}</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="ad-nav-box">
			<div class="ad-nav" :style="'background-image: url(' + adTopbottom.phoneTop + ')'">
				<div class="ad-tou">
					<div class="ad-select-city1" @click="openClose()">
						<div>
							<p>
								{{ this.city }}
								<i class="el-icon-location"></i>
							</p>
						</div>
					</div>
					<div class="ad-unfold" @click="drawer = !drawer">
						<i class="el-icon-s-unfold" style="font-size: 20px; color: white"></i>
					</div>
				</div>
			</div>
		</div>
		<div class="adv-box">
			<div class="top-banner" :style="'background-image: url(' + top.topImg + ')'">
				<div class="top-zi">
					<div @click="skipIndex()" style="margin: 0 15px 0 0; cursor: pointer">
						广东房地产网
					</div>
					|
					<div @click="skipZt()" style="margin: 0 0 0 15px; cursor: pointer">
						专题汇总
					</div>
				</div>
				<div class="intro">
					<div>导语：{{ top.topzi }}</div>
				</div>
			</div>
			<div class="intro1">导语：{{ top.topzi }}</div>
			<div class="adv-bg">
				<div class="adv-left">
					<div class="adv-title">{{ advTitle }}</div>
					<div class="box_hr"></div>
					<div class="lbo">
						<el-carousel :interval="5000" arrow="always" height="380px">
							<el-carousel-item v-for="(i, index) in ztLunBo" :key="index">
								<img @click="ztSkip(i.number)" :src="i.src" style="cursor: pointer" alt />
								<div class="lunbo-title" @click="ztSkip(i.number)" style="cursor: pointer">
									<h5>{{ i.title }}</h5>
								</div>
							</el-carousel-item>
						</el-carousel>
					</div>
					<div class="art-list" v-for="(i, index) in underLunBo" :key="index">
						<div class="nf-wen1">
							<div class="nf-wen1-list">
								<div class="nf-wen1-list-zi" @click="ztSkip(i.number)" style="cursor: pointer">
									{{ i.title }}
								</div>
								<div style="display: flex; justify-content: space-between">
									<div style="color: #618ebc; font-size: 12px">
										{{ i.editor }}
									</div>
									<div
										style="
                      color: rgba(0, 0, 0, 0.5);
                      font-size: 12px;
                      margin: 0 5px 0 0;
                    "
									>
										{{ handleDate(i.time) }}
									</div>
								</div>
								<hr color="#CFCFCF" size="1px" />
							</div>
						</div>
					</div>
					<div class="ad-column">
						<div class="ad-column-name">
							<p>{{ this.leftTitle }}</p>
						</div>
						<div class="ad-column-list">
							<div class="ad-column-list-ul" v-for="(i, index) in leftList" :key="index">
								<div @click="ztSkip(i.number)" class="ad-column-list-ul-img" style="cursor: pointer">
									<img v-lazy="i.src" alt />
								</div>
								<div class="ad-colum-list-content">
									<div class="ad-colum-list-content-top">
										<p @click="ztSkip(i.number)" style="cursor: pointer">
											{{ i.title }}
										</p>
									</div>
									<div class="ad-colum-list-content-mid">
										<p>{{ i.subtitle }}</p>
									</div>
									<div class="ad-colum-list-content-bottom">
										<div>
											<p>
												类型：
												<b>{{ i.column }}</b>
											</p>
										</div>
										<div class="ad-content-time">
											<p>
												<i class="el-icon-time"></i>
												{{ handleDate(i.time) }}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="ad-btn">
						<el-button @click="moreLeft()">查看更多资讯</el-button>
					</div>
				</div>
				<div class="adv-right">
					<div class="adv-title">{{ rightTitle }}</div>
					<div style="overflow: scroll; height: 1000px">
						<div v-for="(i, index) in rightList" :key="index">
							<div class="adv-side">
								<div class="adv-side-content">
									<div class="adv-side-content-title" @click="ztSkip(i.number)" style="cursor: pointer">
										{{ i.title }}
									</div>
									<div class="adv-side-content-bottom">
										<div class="adv-side-content-subtitle">{{ i.editor }}</div>
										<div class="adv-side-content-time">
											{{ handleDate(i.time) }}
										</div>
									</div>
								</div>
								<div class="adv-side-img">
									<img v-lazy="i.src" @click="ztSkip(i.number)" style="cursor: pointer" alt />
								</div>
							</div>
							<hr color="#CFCFCF" size="1px" style="margin: 0 0 20px 0" />
						</div>
					</div>
				</div>
			</div>
			<div class="adv-bg1">
				<div class="adv-list1">
					<div class="adv-list-title">焦点新闻</div>
					<div class="adv-list1-hr"></div>
					<div class="ad-column-list">
						<div class="ad-column-list-ul" v-for="(i, index) in underLunBo" :key="index">
							<div class="ad-column-list-ul-img">
								<img @click="ztSkip(i.number)" v-lazy="i.src" alt />
							</div>
							<div class="ad-colum-list-content">
								<div class="ad-colum-list-content-top">
									<p @click="ztSkip(i.number)">{{ i.title }}</p>
								</div>
								<div class="ad-colum-list-content-mid">
									<p>{{ i.subtitle }}</p>
								</div>
								<div class="ad-colum-list-content-bottom">
									<div>
										<p>
											类型：
											<b>{{ i.aColumn }}</b>
										</p>
									</div>
									<div class="content-time">
										<p>
											<i class="el-icon-time"></i>
											{{ handleDate(i.time) }}
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="adv-list2">
					<div class="adv-list-title">{{ rightTitle }}</div>
					<div class="adv-list1-hr"></div>
					<div v-for="(i, index) in rightList" :key="index">
						<div class="adv-side">
							<div class="adv-side-content">
								<div class="adv-side-content-title" @click="ztSkip(i.number)">
									{{ i.title }}
								</div>
								<div class="adv-side-content-bottom">
									<div class="adv-side-content-subtitle">{{ i.editor }}</div>
									<div class="adv-side-content-time">
										{{ handleDate(i.time) }}
									</div>
								</div>
							</div>
							<div class="adv-side-img">
								<img @click="ztSkip(i.number)" v-lazy="i.src" alt />
							</div>
						</div>
					</div>
					<div v-if="rightList" style="width: 100%; text-align: center; margin: 15px 0 15px 0">
						<el-button @click="moreRight()">查看更多</el-button>
					</div>
				</div>
				<div class="adv-list2">
					<div class="adv-list-title">{{ leftTitle }}</div>
					<div class="adv-list1-hr"></div>
					<div v-for="(i, index) in leftList" :key="index">
						<div class="adv-side">
							<div class="adv-side-content">
								<div class="adv-side-content-title" @click="ztSkip(i.number)">
									{{ i.title }}
								</div>
								<div class="adv-side-content-bottom">
									<div class="adv-side-content-subtitle">{{ i.editor }}</div>
									<div class="adv-side-content-time">
										{{ handleDate(i.time) }}
									</div>
								</div>
							</div>
							<div class="adv-side-img">
								<img @click="ztSkip(i.number)" v-lazy="i.src" alt />
							</div>
						</div>
					</div>
					<div style="width: 100%; text-align: center; margin: 15px 0 15px 0">
						<el-button v-if="leftTitle" @click="moreLeft()">查看更多</el-button>
					</div>
				</div>
			</div>
			<div class="footer">
				<div>
					<p>联系我们，城市加盟</p>
				</div>
				<div>
					<p>微信：{{ adTopbottom.tel }} 邮箱：{{ adTopbottom.eMail }}</p>
				</div>
				<div style="display: flex; margin: auto; justify-content: center">
					<div style="cursor: pointer" @click="beiAn()">
						<p>ICP备案编号：粤ICP备20023176号</p>
					</div>
					<div>
						<p>公安备案编号：4401042001315</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			advTitle: "焦点新闻",
			adTopbottom: {
				phoneTop: "", //控制移动端顶部底部背景颜色
				tel: "", //底部电话
				eMail: "", //底部邮箱
			},
			//当前位置
			city: this.$store.state.city,
			close: false,
			//抽屉
			drawer: false,
			//搜索
			search: "",
			//搜索内容
			searchContent: [],
			//栏目
			column: [
				"全部",
				"公司",
				"人物",
				"政策",
				"评论",
				"财经",
				"楼市",
				"土地",
				"产业地产",
				"商业地产",
				"文旅康养",
				"会议活动",
				"协会",
				"精准扶贫",
				"党建工作",
				"视频",
			],
			region: ["广东省"],
			//专题编号
			specialId: this.$route.query.id,
			//顶部图片
			top: {
				topImg: "",
				topzi: "",
				title: "",
			},
			//轮播
			ztLunBo: [],
			//轮播下文章
			underLunBo: [],
			leftLimit: 6,
			rightLimit: document.body.clientWidth > 768 ? 0 : 6,
			leftList: [],
			leftTitle: "",
			rightList: [],
			rightTitle: "",
		}
	},
	methods: {
		//打开手机选择城市
		openClose() {
			this.close = true
		},
		closeIcon() {
			this.close = false
		},
		//点击城市把city传进vuex
		passCity(e) {
			this.$store.commit("setCity", e)
			// this.$router.go(0)
		},
		//搜索
		async queryArc() {
			const Res = await this.post("/website/queryArc", {
				search: this.search,
				city: this.city,
				limit: this.limit,
			}).catch((err) => {
				console.log(err)
			})
			let tempData = []
			for (var i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					subtitle: Res.data[i].subtitle,
					aColumn: Res.data[i].aColumn,
					time: this.handleDate(Res.data[i].createTime),
					number: Res.data[i].number,
					src: Res.data[i].imgUrl1,
				})
			}
			this.searchContent = tempData
			this.$store.commit("setSearchContent", this.searchContent), this.$store.commit("setAddColumn", "搜索内容"), (this.drawer = false)
		},
		//获取所有城市
		async getCity() {
			const Res = await this.get("/website/getCity", {}).catch((err) => {
				console.log(err)
			})
			for (var i in Res.data) {
				this.region.push(Res.data[i].name)
			}
		},
		//专题活动顶部
		async getTopByZt() {
			const Res = await this.post("/website/getTopByZt", {
				ztUrl: this.specialId,
			}).catch((err) => {
				console.log(err)
			})
			this.top.topImg = Res.data.coverImg
			this.top.topzi = Res.data.intr
			this.top.title = Res.data.title
			this.activated(this.top)
		},
		//专题活动轮播
		async getBannerByZt() {
			const Res = await this.post("/website/getBannerByZt", {
				ztUrl: this.specialId,
			}).catch((err) => {
				console.log(err)
			})
			var tempData = []
			for (let i in Res.data) {
				tempData.push({
					title: Res.data[i].title,
					number: Res.data[i].number,
					src: Res.data[i].picture,
				})
			}
			this.ztLunBo = tempData
		},
		//根据文章id跳转
		ztSkip(e) {
			if (e == null) {
				this.$message({
					message: "该文章已下架",
					type: "warning",
				})
			} else {
				this.$router.push({ path: "/index/article", query: { id: e } })
			}
		},
		//轮播下文章
		async getWzByZt() {
			const Res = await this.post("/website/getWzByZt", {
				ztUrl: this.specialId,
				limit: 5,
			}).catch((err) => {
				console.log(err)
			})
			var tempData = []
			for (let i in Res.data) {
				if (Res.data[i].number == null) {
					continue
				}
				tempData.push({
					title: Res.data[i].title,
					subtitle: Res.data[i].subtitle,
					number: Res.data[i].number,
					src: Res.data[i].imgUrl1,
					time: Res.data[i].createTime,
					editor: Res.data[i].editor,
					aColumn: Res.data[i].aColumn,
				})
			}
			this.underLunBo = tempData
		},
		//获得某城市的顶部底部信息
		async getAdTopBottom() {
			const Res = await this.post("/website/getTopBottom", {
				city: this.city,
			}).catch((err) => {
				console.log(err)
			})
			this.adTopbottom.phoneTop = Res.data.phoneTop
			this.adTopbottom.tel = Res.data.tel
			this.adTopbottom.eMail = Res.data.email
		},
		//左边底部文章列表
		async getDownByZt() {
			const Res = await this.post("/website/getDownByZt", {
				ztUrl: this.specialId,
				limit: this.leftLimit,
			}).catch((err) => {
				console.log(err)
			})
			var tempData = []
			this.leftTitle = Res.data.title
			for (let i in Res.data.WZ) {
				if (Res.data.WZ[i].number == null) {
					continue
				}
				tempData.push({
					title: Res.data.WZ[i].title,
					subtitle: Res.data.WZ[i].subtitle,
					number: Res.data.WZ[i].number,
					src: Res.data.WZ[i].imgUrl1,
					time: Res.data.WZ[i].createTime,
					column: Res.data.WZ[i].aColumn,
					editor: Res.data.WZ[i].editor,
				})
			}
			this.leftList = tempData
		},
		//右边文章列表
		async getRightByZt() {
			const Res = await this.post("/website/getRightByZt", {
				ztUrl: this.specialId,
				limit: this.rightLimit,
			}).catch((err) => {
				console.log(err)
			})
			var tempData = []
			this.rightTitle = Res.data.title
			for (let i in Res.data.WZ) {
				if (Res.data.WZ[i].number == null) {
					continue
				}
				tempData.push({
					title: Res.data.WZ[i].title,
					subtitle: Res.data.WZ[i].subtitle,
					number: Res.data.WZ[i].number,
					src: Res.data.WZ[i].imgUrl1,
					time: Res.data.WZ[i].createTime,
					column: Res.data.WZ[i].aColumn,
					editor: Res.data.WZ[i].editor,
				})
			}
			this.rightList = tempData
		},
		//点击查看更多 右边
		moreRight() {
			this.rightLimit = Number(this.rightLimit) + 3
			this.getRightByZt()
		},
		//点击查看更多 左边
		moreLeft() {
			this.leftLimit = Number(this.leftLimit) + 3
			this.getDownByZt()
		},
		//跳转到主页
		skipIndex() {
			this.$router.push("/index/whole")
		},
		skipZt() {
			this.$router.push("/index/whole")
			this.$store.commit("setColumnTitle", "专题")
			window.scrollTo(0, 800)
		},
		//微信分享
		activated(e) {
			this.$wxShare.updateWxShareConfig({
				title: e.title,
				desc: e.topzi,
				link: window.location.href,
			})
		},
		//跳转备案
		beiAn() {
			window.open("http://www.beian.miit.gov.cn/")
		},
	},
	created() {
		this.getCity()
		this.getAdTopBottom()
		this.getTopByZt()
		this.getBannerByZt()
		this.getWzByZt()
		this.getDownByZt()
		this.getRightByZt()
	},
}
</script>

<style lang="scss" scoped>
.ad-nav-box {
	display: none;
}
.top-banner {
	width: 100%;
	height: 550px;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	-moz-background-size: 100% 100%;
}
.top-zi {
	display: flex;
	color: #fff;
	width: 30%;
	position: relative;
	left: 70%;
	padding: 10px 0 0 0;
}
.intro {
	color: rgb(255, 255, 255);
	position: relative;
	top: 400px;
	div {
		width: 60%;
		margin: auto;
	}
}
.intro1 {
	display: none;
}
.adv-bg {
	display: flex;
	justify-content: space-between;
	width: 80%;
	margin: auto;
}
.adv-bg1 {
	display: none;
}
.adv-left {
	width: 60%;
	margin: 0 30px 0 0;
}
.adv-title {
	width: 100px;
	color: black;
	font-size: 24px;
	font-weight: bold;
	margin: 20px 0 20px 0;
}
.box_hr {
	width: 100%;
	height: 2px;
	background-color: rgba(153, 153, 153, 1);
	margin: 0 0 15px 0;
}
/deep/.el-carousel__item img {
	display: inline-block;
	width: 100%;
	height: 100%;
}
.lunbo-title {
	display: block;
	height: 43px;
	width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	padding: 0 40px 0 40px;
	box-sizing: border-box;
	background-color: rgba($color: #000000, $alpha: 0.4);
	font-size: 35px;
	font-weight: 600;
	position: relative;
	top: -45px;
	color: white;
}
/deep/.el-carousel__indicators--horizontal {
	bottom: 10%;
}
.art-list {
	width: 100%;
	margin: 30px 0 0 10px;
}
.nf-wen1 {
	display: block;
	margin: 0;
	.nf-wen1-list {
		margin: 0 0 0 0;
		width: 100%;
		.nf-wen1-list-zi {
			font-size: 23px;
			height: 28px;
			overflow: hidden;
			margin: 0 0 18px 0;
			//   a {
			//     text-decoration: none;
			//     font-size: 20px;
			//     color: rgb(0, 0, 0);
			//   }
		}
	}
}
.ad-column {
	width: 100%;
	box-sizing: border-box;
}
.ad-column-name {
	font-size: 30px;
	font-weight: 600;
	margin: 40px 0 10px 10px;
}
.ad-column-list-ul {
	display: flex;
	height: 170px;
	margin: 20px 25px 0 25px;
}
.ad-column-list-ul-img {
	width: 250px;
	height: 160px;
	img {
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}
}
.ad-colum-list-content {
	margin: 0 0 0 25px;
	height: 160px;
	position: relative;
	width: 100%;
	.ad-colum-list-content-top {
		p {
			font-size: 18px;
			color: black;
		}
	}
	//   .h1title {
	//     text-decoration: none;
	//     font-size: 24px;
	//     color: #000000;
	//   }
	p {
		font-size: 15px;
		color: rgba($color: #000000, $alpha: 0.5);
	}
	.ad-colum-list-content-mid {
		position: absolute;
		bottom: 60px;
		width: 100%;
	}
	.ad-colum-list-content-bottom {
		display: flex;
		width: 100%;
		justify-content: space-between;
		position: absolute;
		bottom: 0px;
		p {
			color: rgba($color: #000000, $alpha: 0.7);
		}
		b {
			color: rgba(11, 104, 192, 0.7);
		}
	}
	.ad-content-time {
		float: right;
		p {
			color: rgba($color: #000000, $alpha: 0.5);
		}
	}
}
.ad-btn {
	width: 100%;
	text-align: center;
	margin: 40px 0 40px 0;
}
.adv-right {
	width: 40%;
	margin: 0 0 0 20px;
}
.adv-side {
	display: flex;
	margin: 0 0 30px 0;
}
.adv-side-img {
	width: 230px;
	height: 100px;
	margin: 0 0 0 20px;
	img {
		width: 100%;
		height: 100%;
	}
}
.adv-side-content {
	width: 100%;
	height: 100px;
	position: relative;
}
.adv-side-content-title {
	font-size: 22px;
	height: 60px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.adv-side-content-bottom {
	display: flex;
	position: absolute;
	justify-content: space-between;
	height: 21px;
	bottom: 0px;
	color: rgba(162, 162, 162, 1);
	width: 100%;
	.adv-side-content-subtitle {
		width: 40%;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}
	.adv-side-content-time {
		margin: 0 0 0 20%;
	}
}
.footer {
	box-sizing: border-box;
	margin-top: 0px;
	height: 210px;
	color: #fff;
	background-image: url("../assets/footer1.jpg");
	// background-repeat: repeat-x;
	// background-size: auto 100%;
	// -moz-background-size: auto 100%;
	background-repeat: no-repeat;
	background-size: 100% 100%;
	-moz-background-size: 100% 100%;
	z-index: 9999;
	clear: both;
	p {
		position: relative;
		top: 20px;
		margin: 10px;
		text-align: center;
	}
}
@media (max-width: 768px) {
	.ad-nav-box {
		display: block;
	}
	.choose-city {
		position: fixed;
		z-index: 9999;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(230, 230, 230, 0.97);
	}
	.icon-close {
		position: absolute;
		top: 4%;
		left: 85%;
		font-size: 30px;
	}
	.choose-city-content {
		padding-top: 10px;
		margin-top: 10px;
	}
	.choose-city-content1 {
		margin-left: auto;
		margin-right: auto;
	}
	.choose-city-boxs {
		margin: 0 20px 0 20px;
		box-sizing: border-box;
	}
	.choose-city-txt1 {
		font-size: 14px;
		color: #999;
		line-height: 40px;
		height: 40px;
		vertical-align: middle;
		margin: 0px;
	}
	.choose-city-box {
		display: block;
	}
	.showcity {
		width: 30.33%;
		background-color: #fff;
		line-height: 38px;
		font-size: 14px;
		margin-left: 3%;
		margin-top: 15px;
		text-align: center;
		box-sizing: border-box;
		a {
			text-decoration: none;
			color: #666;
		}
	}
	.showcity1 {
		width: 30.33%;
		float: left;
		background-color: #fff;
		line-height: 38px;
		font-size: 14px;
		margin-left: 3%;
		margin-top: 15px;
		text-align: center;
		box-sizing: border-box;
		a {
			text-decoration: none;
			color: #666;
		}
	}
	.ad-nav {
		// background-color: blue;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		-moz-background-size: 100% 100%;
		height: 50px;
		width: 100%;
	}
	.ad-tou {
		position: relative;
		padding-top: 15px;
		left: 70%;
		width: 30%;
		display: flex;
	}
	.ad-select-city1 {
		color: #fff;
		display: flex;
	}
	/deep/.el-drawer {
		background-color: transparent;
		color: white;
		/deep/.el-input__inner {
			width: 130% !important;
		}
		ul {
			margin: 0 0 0 20px;
			li {
				list-style-type: none;
				margin: 0 0 20px 0;
				a {
					text-decoration: none;
					color: white;
				}
			}
		}
	}
	/deep/.el-drawer {
		width: 100% !important;
	}
	/deep/.el-drawer__body {
		overflow: auto;
	}
	/deep/.el-drawer__wrapper {
		top: 50px;
	}
	.adv-box {
		position: absolute;
		top: 50px;
		width: 100%;
		background-color: #efefef;
	}
	.top-banner {
		height: 150px;
	}
	.ad-unfold {
		float: right;
		margin: 2px 0 0 20px;
	}
	.top-zi {
		display: none;
	}
	.intro {
		display: none;
	}
	.intro1 {
		display: block;
		color: rgba(16, 15, 0, 1);
		height: 50px;
		font-size: 10px;
		font-weight: bold;
		margin: 10px;
	}
	.adv-bg {
		display: none;
	}
	.adv-bg1 {
		display: block;
		margin: 20px 0 0 0;
	}
	.adv-list-title {
		color: rgba(0, 0, 0, 1);
		font-weight: bold;
		font-size: 17px;
		margin: 10px 0 10px 15px;
	}
	.adv-list1-hr {
		width: 90%;
		margin: 0 4% 15px 4%;
		height: 1px;
		background-color: rgba(153, 153, 153, 1);
	}
	.nf-column-list {
		border: none;
	}
	.ad-column-list-ul {
		height: 100px;
		display: flex;
		margin: 0 15px 0 15px;
	}
	.ad-column-list-ul-img {
		width: 180px;
		height: 80px;
	}
	.ad-colum-list-content {
		margin: 0 0 0 15px;
		height: 80px;
		.ad-colum-list-content-top {
			height: 35px;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			margin: -3px 0 0 0;
			p {
				font-size: 13px;
			}
		}
		// .h1title {
		//   text-decoration: none;
		//   font-size: 15px;
		//   color: rgba($color: #000000, $alpha: 0.7);
		// }
		p {
			font-size: 8px;
			color: rgba($color: #000000, $alpha: 0.5);
		}
		.ad-colum-list-content-mid {
			top: 55%;
			min-width: 0;
			p {
				height: 14px;
				overflow: hidden;
				text-overflow: ellipsis;
				display: -webkit-box;
				-webkit-line-clamp: 1;
				-webkit-box-orient: vertical; /* 垂直排列 */
				word-break: break-all;
			}
		}
	}
	.adv-side {
		margin: 0 13px 20px 13px;
		height: 80px;
	}

	.adv-side-img {
		width: 180px;
		height: 80px;
	}
	.adv-side-content {
		height: 80px;
	}
	.adv-side-content-title {
		font-size: 16px;
		height: 50px;
	}
	.adv-side-content-bottom {
		font-size: 10px;
		height: 18px;
	}
	.adv-side-content-subtitle {
		width: 50%;
	}
	.footer {
		background-image: url("../assets/footer5.png");
		height: 100px;
		p {
			position: relative;
			top: 5px;
			margin: 5px;
			text-align: center;
			font-size: 12px;
		}
	}
}
</style>
